import { useState } from "react";
import { ChevronDown, MoreHorizontal } from "lucide-react";
import formatCurrency from "@/utils/formatCurrency";
import ExpenseRow from "@/components/dashboard/ExpenseRow";

const ExpenseAccordion = ({ category, expenses, onUpdate, icons }) => {
  const [isOpen, setIsOpen] = useState(false);
  const categoryExpenses = expenses.filter((e) => e.category === category);
  const categoryTotal = categoryExpenses.reduce((sum, e) => sum + (e.is_monthly ? e.monthly_amount * 12 : e.yearly_amount), 0);

  return (
    <div className="border-b border-gray-100" data-testid={`expense-accordion-${category.replace(/\s+/g, '-').toLowerCase()}`}>
      <button className="accordion-trigger" onClick={() => setIsOpen(!isOpen)}>
        <span className="font-semibold text-gray-800">{category}</span>
        <div className="flex items-center gap-4">
          <span className="text-gray-600 font-medium">₹{formatCurrency(categoryTotal)}</span>
          <ChevronDown className={`chevron-icon text-gray-400 ${isOpen ? "rotate-180" : ""}`} size={20} />
        </div>
      </button>
      {isOpen && (
        <div className="px-4 pb-4 space-y-3">
          {categoryExpenses.map((expense, idx) => {
            const globalIndex = expenses.findIndex((e) => e.category === expense.category && e.subcategory === expense.subcategory);
            const IconComponent = icons[expense.subcategory] || MoreHorizontal;
            return <ExpenseRow key={`${expense.category}-${expense.subcategory}`} icon={IconComponent} label={expense.subcategory} expense={expense} onUpdate={onUpdate} index={globalIndex} />;
          })}
        </div>
      )}
    </div>
  );
};

export default ExpenseAccordion;
